import styled from "styled-components";

export const Button = styled.button`
  color: var(--font-color-emp);
  background: transparent;
  font-weight: 700;
  margin-left: 10px;
  letter-spacing: 2px;
  box-shadow: none;
  border-radius: 50%;
  outline: none;
  border: none !important;
  font-size: 16px;
`;
